export default "__VITE_ASSET__DYQci3CF__"